<span class="area-label" [style.fontSize]="fontSize" title="Área">
    <i class="fas fa-layer-group"></i> {{nome}}
</span>